module.exports = __webpack_public_path__ + "img/icon-question-gray.95e07ae2.svg";